/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';

/**
 * 
 * @export
 * @interface CreateExternalMediaResponse
 */
export interface CreateExternalMediaResponse {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof CreateExternalMediaResponse
     */
    id: ApiUserTasksGetLastSelectedIdParameter;
}

/**
 * Check if a given object implements the CreateExternalMediaResponse interface.
 */
export function instanceOfCreateExternalMediaResponse(value: object): value is CreateExternalMediaResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function CreateExternalMediaResponseFromJSON(json: any): CreateExternalMediaResponse {
    return CreateExternalMediaResponseFromJSONTyped(json, false);
}

export function CreateExternalMediaResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateExternalMediaResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['id']),
    };
}

export function CreateExternalMediaResponseToJSON(json: any): CreateExternalMediaResponse {
    return CreateExternalMediaResponseToJSONTyped(json, false);
}

export function CreateExternalMediaResponseToJSONTyped(value?: CreateExternalMediaResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterToJSON(value['id']),
    };
}

